module.exports = __webpack_public_path__ + "img/like.eb362e0b.svg";